import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-12 px-4 bg-brown text-cream" data-id="element-48">
      <div className="max-w-2xl mx-auto flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-49">
        <div className="flex-shrink-0" data-id="element-50">
          <ShieldCheck className="w-12 h-12 text-sage-light" data-id="element-51" />
        </div>
        <div data-id="element-52">
          <h3 className="text-lg font-bold font-heading mb-2" data-id="element-53">
            Garantía de Confianza
          </h3>
          <p className="text-cream/80 font-body text-sm leading-relaxed" data-id="element-54">
            Tu compra es 100% segura y el acceso al PDF es inmediato una vez
            realizado el pago. Podés leerlo desde tu celu, tablet o compu.
          </p>
        </div>
      </div>
    </section>;
}